"use strict";

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

// Contact section openers
var contactOpeners = document.querySelectorAll('[data-js-contact-opener]');

if (contactOpeners) {
  var contactSection = document.querySelector('.contact-section');
  [].forEach.call(contactOpeners, function (contactOpener) {
    contactOpener.addEventListener('click', function (event) {
      contactSection.classList.toggle('contact-section-is-open');
      var hash = window.location.hash;

      if (hash === '#contact' || hash === '#kontakt') {
        window.history.pushState('', document.title, window.location.pathname);
      } else {
        window.location.hash = "".concat(document.querySelector('.btn-contact').getAttribute('href'));
      }

      event.preventDefault();
    });
  });
  var hash = window.location.hash;

  if (hash === '#contact' || hash === '#kontakt') {
    contactSection.classList.toggle('contact-section-is-open');
  }
}

var body = document.querySelector('body'); // IE and Edge detektor

var isIE = navigator.userAgent.indexOf("MSIE ") > -1 || navigator.userAgent.indexOf("Trident/") > -1 || navigator.userAgent.indexOf("Edge/") > -1;

if (isIE) {
  body.classList.add('is-ie');
} // Init typed.js


var typedWelcome = new Typed('.welcome-section .suffix', {
  strings: ["", "ski"],
  cursorChar: '_',
  loop: true,
  typeSpeed: 60,
  backSpeed: 60,
  backDelay: 1500,
  startDelay: 3000
});
var typedSubmenu = new Typed('.submenu-section .suffix', {
  strings: ["", "ski"],
  cursorChar: '_',
  loop: true,
  typeSpeed: 60,
  backSpeed: 60,
  backDelay: 1500,
  startDelay: 3000
}); // Format number

var numberWithCommas = function numberWithCommas(x) {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
}; // Init masonry


var macyContainer = document.querySelector('.js-macy-container');

if (macyContainer) {
  var masonry = new Macy({
    container: '.js-macy-container',
    trueOrder: false,
    waitForImages: false,
    useOwnImageLoader: false,
    mobileFirst: true,
    columns: 1,
    margin: 50,
    breakAt: {
      800: 2
    }
  });
  window.addEventListener('resize', function () {
    masonry.reInit();
    masonry.recalculate(true);
  });
} // Detect request animation frame


var animationFrame = window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || window.msRequestAnimationFrame || window.oRequestAnimationFrame // IE Fallback, you can even fallback to onscroll
|| function (callback) {
  window.setTimeout(callback, 1000 / 60);
};

var lastPosition = -1;

function scrollLoop() {
  // Avoid calculations if not needed
  if (lastPosition == window.pageYOffset) {
    animationFrame(scrollLoop);
    return false;
  }

  lastPosition = window.pageYOffset;
  scrollListener(lastPosition);
  animationFrame(scrollLoop);
}

scrollLoop(); // Submenu pin

var welcomeSection = document.querySelector('.welcome-section');
var submenuSection = document.querySelector('.submenu-section');

function scrollListener(top) {
  if (submenuSection) {
    var submenuTop = welcomeSection ? welcomeSection.clientHeight : 0;
    submenuSection.classList.toggle('is-fixed', top >= submenuTop);
  }
} // Press


var pressSection = document.querySelector('.press-section');

if (pressSection) {
  var showMoreBtn = pressSection.querySelector('.js-press-show-more');

  if (showMoreBtn) {
    showMoreBtn.addEventListener('click', function (event) {
      [].forEach.call(pressSection.querySelectorAll('.press__item.is-hidden'), function (hiddenItem, index) {
        setTimeout(function () {
          hiddenItem.classList.remove('is-hidden');
          setTimeout(function () {
            hiddenItem.classList.remove('is-visually-hidden');
          }, 200);
        }, 200 * index);
      });
      showMoreBtn.setAttribute('hidden', '');
      event.preventDefault();
    });
  }
} // Light Gallery


var initGallery = function initGallery() {
  var galleryElements = _toConsumableArray(document.querySelectorAll('.js-lightgallery'));

  galleryElements.forEach(function (gallery) {
    lightGallery(gallery, {
      selector: '.js-lightgallery-link'
    });
  });
};

initGallery(); // Instagram feed

var instagramFeed = document.querySelector('.js-instagram-feed');

if (instagramFeed) {
  var instagramFeedHTML = '';
  var instagramLikes;
  fetch(window.LOAD_INSTAGRAM_FEED_URL).then(function (response) {
    return response.json();
  }).then(function (feed) {
    if (feed && feed.length) {
      window.localStorage.setItem('instagramFeed', JSON.stringify(feed));
    } else if (window.localStorage.getItem('instagramFeed')) {
      feed = JSON.parse(window.localStorage.getItem('instagramFeed'));
    }

    feed.forEach(function (post) {
      instagramLikes = numberWithCommas(post.likes);
      instagramFeedHTML += "\n          <a class=\"instagram__block-item\" href=\"https://www.instagram.com/p/".concat(post.code, "\" target=\"_blank\">\n                <img src=\"").concat(post.thumbnail_src, "\" alt=\"").concat(post.caption, "\">\n                <div class=\"overlay\">\n                    <svg width=\"33\" height=\"31\" viewBox=\"0 0 33 31\" xmlns=\"http://www.w3.org/2000/svg\">\n                        <path d=\"M16.381 30.48l-2.242-2.31C5.82 20.566.381 15.439.381 9.15c0-5.117 3.844-9.09 8.796-9.09 2.728 0 5.446 1.326 7.204 3.473C18.14 1.385 20.857.06 23.585.06c4.952 0 8.796 3.972 8.796 9.089 0 6.289-5.438 11.416-13.758 19.022l-2.242 2.308z\" fill=\"#1D1D1B\" fill-rule=\"evenodd\"/>\n                    </svg>\n                    <span class=\"likes\">\n                        ").concat(instagramLikes, "\n                    <span>\n                </div>\n            </a>\n        ");
    });
  }).then(function () {
    instagramFeed.innerHTML = instagramFeedHTML;
  });
}